import React from 'react';
import ReactDOM from 'react-dom/client';
import {enableMapSet} from 'immer';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import './index.css';


enableMapSet()
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);